import clienteAxios from "../config/axios";

export async function getAllAtributosFichaTecnica() {
    return clienteAxios.get(`/atributosFichaTecnica`);
}

export async function addAtributoFichaTecnica(atr){
    return clienteAxios.post('/atributosFichaTecnica',{atr});
}

export async function updateAtributoFichaTecnica(atr){
    return clienteAxios.put('/atributosFichaTecnica',{updates:atr});
}

export async function deleteAtributoFichaTecnica(idAtr){
    return clienteAxios.delete(`/atributosFichaTecnica/${idAtr}`);
}
